import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '8px 16px',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  '& .MuiListItemIcon-root': {
    minWidth: '36px',
  },
  '& .MuiListItemText-root': {
    margin: 0,
    '& .MuiTypography-root': {
      lineHeight: '22px',
      fontWeight: 500,
      letterSpacing: '-0.41px',
      fontSize: '14px',
    },
  },
})); 